import {api} from '../../../shared';
import {ClientVersionsWithMetaModel, ClientVersionsFilter, CreateClientVersionDTO, ClientVersionModel} from '../model';

export const clientVersionsApi = {
  getClientVersions: async (params: ClientVersionsFilter = {}): Promise<ClientVersionsWithMetaModel> => {
    const {data} = await api.get<ClientVersionsWithMetaModel>('/api/client-versions/admin/client-versions', {params});
    return data;
  },

  createClientVersion: async (version: CreateClientVersionDTO): Promise<ClientVersionModel> => {
    const {data} = await api.post<ClientVersionModel>('/api/client-versions/admin/client-versions', version);
    return data;
  },

  deleteClientVersion: async (clientVersionId: string): Promise<void> => {
    await api.delete(`/api/client-versions/admin/client-versions/${clientVersionId}`);
  },
};
